module.exports = __webpack_public_path__ + "static/wix-icon-26b11e939d78b39460daa39317b1cfd6.png";